export const thankyouTranslate = {
  es: {
    summary: {
      title: "¡Ya tienes tu membresía!",
      summary: "Resumen de tu compra",
      membershipType: "Tipo de membresía",
      email: "Email",
      expirationDate: "Fecha de expiración",
      automaticRenewal: "Renovación automática",
      automaticRenewalDetails: (date) =>
        `Tu membresía se renovará automáticamente el ${date}. Puedes cancelar la renovación en cualquier momento.`,
      paymentType: "Tipo de pago",
      customerId: "Número de usuario id",
      yourPayment: "Tu pago",
      renewalCost: "Costo de renovación",
      payments: "1 de 12 pagos",
      buttonLogin: "Ir al Dashboard",
    },
    slides: {
      reservation: "Tu siguiente reservación",
      reservationItems: [
        {
          title: "Inicia sesión con tu cuenta",
          subtitle:
            "Solo podrás acceder a los beneficios si compras dentro del sitio con tu cuenta Viva Fan.",
        },
        {
          title: "Descubre los beneficios",
          subtitle:
            "Busca tu vuelo y visualiza el descuento Viva Fan o utiliza tus vuelos incluidos si eres Viva Fan Plus",
        },
        {
          title: "Viva Fan",
          subtitle:
            "Disfruta tu vuelo con la membresía para el viajero inteligente.",
        },
      ],
      enjoy: "Comienza a disfrutar",
      enjoyItems: [
        {
          title: "Acceso a precios exclusivos",
          subtitle:
            "Ahorra hasta $400 mxn en vuelos nacionales y hasta $20 USD en vuelos internacionales.",
        },
        {
          title: "Más equipaje incluido",
          subtitle:
            "Al reservar en Extra o Smart podrás viajar con 5kg o 7kg adicionales de carry on o documentado*.",
        },
        {
          title: "Acceso a ventas especiales",
          subtitle: "Recibirás promociones especiales por ser Viva Fan.",
        },
        {
          title: "Acceso a Smile & Fly ",
          subtitle: "Documenta y aborda el avión con reconocimiento facial.",
        },
      ],
    },
  },
  eng: {
    summary: {
      title: "You are already a Viva Fan member!",
      summary: "You are already a Viva Fan member!",
      membershipType: "Membership Type",
      email: "E-mail",
      expirationDate: "Expiration date",
      automaticRenewal: "Automatic renewal",
      automaticRenewalDetails: (date) =>
        `Your membership will automatically renew on ${date}. You can cancel the renewal at any time before this date.`,
      paymentType: "Payment type",
      customerId: "Customer ID",
      yourPayment: "Your payment",
      renewalCost: "Renewal cost",
      payments: "1 of 12 payment",
      buttonLogin: "Go to Dashboard",
    },
    slides: {
      reservation: "Your next booking",
      reservationItems: [
        {
          title: "Log in with your account",
          subtitle:
            "You will only be able to access the benefits if you buy on the site with your Viva Fan account.",
        },
        {
          title: "Discover the prices and benefits",
          subtitle:
            "Find your flight, view the Viva Fan discount and benefits.",
        },
        {
          title: "You are a Viva Fan",
          subtitle: "Enjoy your flight with membership for the smart traveler.",
        },
      ],
      enjoy: "Start enjoying",
      enjoyItems: [
        {
          title: "Access to exclusive prices",
          subtitle:
            "Save up to $400 mxn on domestic flights and up to $20 USD on international flights.",
        },
        {
          title: "More luggage included",
          subtitle:
            "When booking in Extra or Smart you can travel with an additional 5kg or 7kg of carry on or documented*.",
        },
        {
          title: "Access to special sales",
          subtitle: "You will receive special promotions for being Viva Fan.",
        },
        {
          title: "Access to Smile & Fly",
          subtitle:
            "Access to Smile & Fly Document and board the plane with facial recognition.",
        },
      ],
    },
  },
};
